const BEST_COUPON_SERVICE_URL = 'cart/best-coupons';
const BEST_COUPON_SERVICE_URL_AURORA = 'best-coupon';
const EXP_COM_COUPON_SERVICE_URL = 'content/coupons';
const CM_COUPON_SERVICE_URL = '/content-aggregator/content/coupon-tiles';

export default {
    BEST_COUPON_SERVICE_URL,
    BEST_COUPON_SERVICE_URL_AURORA,
    EXP_COM_COUPON_SERVICE_URL,
    CM_COUPON_SERVICE_URL,
};
